import TomSelect from 'tom-select';
import detailsBooking from './details-booking';
import bookingInitDataStorage from '../../../init/data-storage';
import bookingDataStorage from '../../../data-storage';

const modDetailsBooking = new detailsBooking();

export default class bookingPlayers{

    private modDataStorage = new bookingInitDataStorage();

    private modBookingDataStorage = new bookingDataStorage();

    /**
     * Get Players
     * @returns 
     */
    getPlayers(el_players: string){
        
        const control = new TomSelect(el_players, {
            plugins: ['dropdown_input'],
            allowEmptyOption: true,
            persist: false,
            valueField:'id',
            render: {
                option: function (item, escape) {
                    return '<span class="block w-full fluid-text-xs">'+ escape(item.text) +'</span>';
                },
                item: function (item, escape) {
                    return '<span>'+ escape(item.text) +'</span>';
                },
            }
        });

        control.disable();

        return control;

    }

    /**
     * Set players
     * @param control 
     * @param players 
     */
    setPlayers(control: any, players: number, date: string, minPlayersWeekday: number, minPlayersWeekend: number){
        
        control.enable();
        control.clear();
        control.clearOptions();

        const dayOfWeek = new Date(date).getDay(); // 0 = Domenica, ..., 6 = Sabato
        const minPlayers = (dayOfWeek >= 1 && dayOfWeek <= 5) ? minPlayersWeekday : minPlayersWeekend;

        let options: { [key: string]: { id: string, text: string } } = {};

        for(let i = minPlayers; i <= players; i++){
            
            options[i.toString()] = { id: i.toString(), text: i.toString() };

        }

        control.addOptions(options, false);

        this.setPlayerValue(control);

    }

    /**
     * Change players
     * @param el_players 
     * @param book_calendar 
     * @param el_rooms 
     * @param el_games 
     * @param el_time_slot 
     */
    changePlayers(
        el_players: string,
        book_calendar: any,
        el_rooms: string,
        el_games: string,
        el_time_slot: string,
    ){

        // Element players
        const elPlayers = document.querySelector(el_players) as HTMLSelectElement | null;

        elPlayers?.addEventListener('change', function (e){
            
            e.preventDefault();

            // Get details booking
            modDetailsBooking.getDetailsBooking(
                book_calendar,
                el_rooms,
                el_games,
                el_time_slot,
                el_players
            );

        });
 
    }

    /**
     * Set game
     * @param control 
     */
    protected setPlayerValue(control: any) {
        
        const storeInitData = this.modDataStorage.getLocalStorage();

        if(storeInitData !== null){
            
            // Set value
            const get_players = storeInitData?.players as unknown as string;

            control.setValue(get_players);

        }else{
            
            // Retrieve stored booking data
            const storedValues = this.modBookingDataStorage.getLocalStorage();

            // Set value
            const get_players = storedValues?.players as unknown as string | null;

            if(get_players !== null){
                
                if(control.options[get_players]){
                    
                    control.setValue(get_players);

                }else{
                    
                    const firstValue = Object.keys(control.options)[0];

                    if(firstValue){
                        
                        control.setValue(firstValue);

                    }

                }

            }

        }

    }

}